import React, { useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Box,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
} from '@mui/material';
import { toast } from "react-toastify";
import axios from "../../api/axios_client";
import { url } from "../../api/axios_client";
import './style.css';

const PredictionResponseComponent = ({ predictionResponse }) => {
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [uploading, setUploading] = useState(false);
  const [predictionName, setPredictionName] = useState("");

  const countries = [
    "Algeria", "Bahrain", "Comoros", "Djibouti", "Egypt", "Iraq", "Jordan",
    "Kuwait", "Lebanon", "Libya", "Mauritania", "Morocco", "Oman", "Palestine",
    "Qatar", "Saudi Arabia", "Somalia", "Sudan", "Syria", "Tunisia",
    "United Arab Emirates", "Yemen"
  ];

  const handleUpload = async () => {
    if (!selectedCountry || !predictionName) {
      toast.error("Please fill in all required fields");
      return;
    }

    try {
      setUploading(true);
      const response = await axios.post(`${url}/reports`, {
        source: "prediction",
        name: predictionName,
        country: selectedCountry,
        container: predictionResponse.uploaded_blob.container,
        blob: predictionResponse.uploaded_blob.blob,
      });

      if (response.status === 201) {
        toast.success("Prediction report uploaded successfully");
        setOpenUploadDialog(false);
      } else {
        toast.error("Failed to upload prediction report");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      setUploading(false);
    }
  };

  if (!predictionResponse) {
    return null;
  }

  const { results_table, download_url, imgdata } = predictionResponse;

  const renderTable = () => {
    if (!results_table || Object.keys(results_table).length === 0) {
      return null;
    }

    let headers = Object.keys(results_table);
    const rowIndices = Object.keys(results_table.color);

    return (
      <TableContainer style={{ height: "calc(100vh - 200px)" }} component={Paper}>
        <Table stickyHeader style={{ borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell key={header} sx={{ whiteSpace: 'nowrap' }}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowIndices.map((rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((header) => (
                  <TableCell key={header}>
                    {header === "color" ? (
                      <Box display="flex" alignItems="center">
                        <Box
                          sx={{
                            width: '20px',
                            height: '20px',
                            backgroundColor: `rgb(${results_table[header][rowIndex].join(',')})`,
                            border: '1px solid #000',
                            marginRight: '8px',
                          }}
                        />
                      </Box>
                    ) : (
                      Array.isArray(results_table[header][rowIndex])
                        ? results_table[header][rowIndex].join(', ')
                        : results_table[header][rowIndex]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={4}
      p={3}
      height="calc(100vh - 100px)"
    >
      <Box
        width="40%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
      >
        {imgdata && (
          <img
            src={`data:image/png;base64,${imgdata}`}
            alt="Prediction Result"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: 'calc(100vh - 200px)',
              objectFit: 'contain',
              borderRadius: '8px'
            }}
          />
        )}
        {download_url && (
          <Button
            variant="contained"
            color="primary"
            href={download_url}
            target="_blank"
            rel="noopener noreferrer"
            className='pred-download-button'
          >
            Download Prediction Data
          </Button>
        )}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpenUploadDialog(true)}
        >
          Upload to Repository
        </Button>
      </Box>

      <Box width="60%">
        <Typography variant="h5" gutterBottom>
          Prediction Results
        </Typography>
        {renderTable()}
      </Box>

      <Dialog
        open={openUploadDialog}
        onClose={() => setOpenUploadDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <Box p={3}>
          <Typography variant="h6" gutterBottom>
            Upload Prediction to Repository
          </Typography>

          <Box display="flex" flexDirection="column" gap={3} mt={2}>
            <FormControl fullWidth>
              <InputLabel>Prediction Name</InputLabel>
              <Input
                value={predictionName}
                onChange={(e) => setPredictionName(e.target.value)}
              />
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Select Country</InputLabel>
              <Select
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
                label="Select Country"
              >
                {countries.map((country) => (
                  <MenuItem key={country} value={country}>
                    {country}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Box display="flex" gap={2} justifyContent="flex-end">
              <Button
                onClick={() => setOpenUploadDialog(false)}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                disabled={uploading || !selectedCountry || !predictionName}
              >
                {uploading ? "Uploading..." : "Upload"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default PredictionResponseComponent;